

export default {
  name: "areaStyle",
  nickname: "分隔区域样式",
  desc: "分隔区域的样式设置。",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        "分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。",
      value: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"],
      defaultValue: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"],
      type: "pureValue",
      eType: "color",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
  },
}
